import { Link } from 'react-router-dom'
import { Offcanvas, Button } from 'react-bootstrap'
import { SHOP_LIST_PATH } from '../../../constants/constants'
import WholesaleInfo from '../../molecules/Site/WholesaleInfo'
import { useNavigate } from 'react-router-dom'
import { useUserContext } from '../../../context/user/UserProvider'
import { BsFillMoonFill, BsSunFill } from 'react-icons/bs'
import ProLineSideNavMenuItemsMobile from '../../molecules/Shop/ProLineSideNavMenuItemsMobile'
import { GiFireworkRocket } from 'react-icons/gi'
import { FaNewspaper, FaPhoneAlt } from 'react-icons/fa'
import { IoNotifications } from 'react-icons/io5'

interface IProLineOffcanvasMobileProps {
  show: boolean
  handleClose: () => void
}

const ProLineOffcanvasMobile: React.FC<IProLineOffcanvasMobileProps> = ({
  show,
  handleClose,
}) => {
  const navigate = useNavigate()
  const { isDarkMode, setDarkMode } = useUserContext()

  const toggleDarkMode = () => {
    setDarkMode(!isDarkMode)
  }

  return (
    <Offcanvas show={show} onHide={handleClose} scroll={true}>
      <Offcanvas.Header className="justify-content-center dflex">
        <div>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={handleClose}
            style={{ position: 'static' }}
          />
        </div>
      </Offcanvas.Header>
      <Offcanvas.Body className="p-0">
        <ProLineSideNavMenuItemsMobile handleClick={handleClose} />
        {/* This data for these buttons should probably be moved into the site_menus table later. */}
        <Button
          variant="danger"
          onClick={() => {
            navigate('/fireworks-show-builder')
            handleClose?.()
          }}
          className="ms-3 me-3 mt-2 mb-2"
        >
          <GiFireworkRocket /> '76 Show Builder
        </Button>
        <br />
        <Button
          variant="danger"
          onClick={() => {
            navigate('/news')
            handleClose?.()
          }}
          className="ms-3 me-3 mt-2 mb-2"
        >
          <FaNewspaper /> News & Blog
        </Button>
        <br />
        <Button
          variant="danger"
          onClick={() => {
            navigate('/newsletter')
            handleClose?.()
          }}
          className="ms-3 me-3 mt-2 mb-2"
        >
          <IoNotifications /> Newsletter Subscribe
        </Button>
        <br />
        <Button
          variant="danger"
          onClick={() => {
            navigate('contact')
            handleClose?.()
          }}
          className="ms-3 me-3 mt-2 mb-2"
        >
          <FaPhoneAlt /> Contact Us
        </Button>
        <br />
        <Button
          variant={isDarkMode ? 'secondary' : 'primary'}
          onClick={toggleDarkMode}
          className="ms-3 mt-3"
        >
          <span>{isDarkMode ? <BsSunFill /> : <BsFillMoonFill />}</span>
          <span className={'ms-2'}>
            {isDarkMode ? 'Disable ' : 'Enable'} Dark Mode
          </span>
        </Button>
        <WholesaleInfo />
        <br /> {/* Just some space so you can see the contact email. */}
      </Offcanvas.Body>
    </Offcanvas>
  )
}

export default ProLineOffcanvasMobile
